import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'mc-datetime-picker-wrapper',
  templateUrl: './datetime-picker-wrapper.component.html',
  styleUrls: ['./datetime-picker-wrapper.component.scss']
})
export class DatetimePickerWrapperComponent implements OnInit {

  @Input() inputDate: Date;

  /**
 * the event passing the selected date
 */
  @Output() dateSelected = new EventEmitter<any>();

  modelDate: Date = null;

  constructor() {

  }

  public disabled = false;

  ngOnInit() {
    if (this.inputDate) {
      this.setModelDate();
    }
  }

  /**
    * Handler for the onChanges event
    * @param changes The changes on the view
    */
  ngOnChanges(changes: any): void {
    if (changes && changes.inputDate && !changes.inputDate.firstChange) {
      if (changes.inputDate.currentValue != changes.inputDate.previousValue) {
        // If a date field has been blanked out, it is set to the string 'Invalid date'.  Treat those as null
        if (changes.inputDate.currentValue && changes.inputDate.currentValue !== 'Invalid date') {
          this.setModelDate();
        } else {
          this.modelDate = null;
        }
      }
    }

  }

  setModelDate(): void {
    this.modelDate = new Date(moment(this.inputDate).format("MM/DD/YYYY hh:mm:ss A"));
    document.getElementById('registrationTime').setAttribute('value', `${this.getAsTwoDigits(this.modelDate.getHours())}:${this.getAsTwoDigits(this.modelDate.getMinutes())}`);
  }

  getAsTwoDigits(num: number): string {
    return (num < 10 ? '0' : '') + num;
  }

  /**
   * Sets the date input by the user
   */
  setManualDate(): void {
    // if it's an invalid date entered manually, set it to null
    // and notify
    if (!moment.isDate(this.modelDate)) {
      this.modelDate = null;
    }
    this.onDateSelected(this.modelDate);
  }

  /**
   * Sets the time input by the user
   */
  setModelTime(e: any): void {
    const time: string = e.target.value;
    const [hours, minutes] = time.split(':');
    this.modelDate.setHours(parseInt(hours));
    this.modelDate.setMinutes(parseInt(minutes));
    this.modelDate.setSeconds(0, 0);
    this.fireDateUpdatedEvent(this.modelDate);
  }



  /**
   * Handles the event fired from the UI when a date is selected
   * @param event The date that was selected
   */
  public onDateSelected(event): void {
    this.fireDateUpdatedEvent(this.modelDate);
  }


  /**
   * Fires the event to inform the host and return the selected date
   * @param newDate Selected date from the datepicker
   */
  fireDateUpdatedEvent(newDate: any) {
    this.dateSelected.emit(newDate);
  }


}


